import AmexGDAReferFriend from './AmexGDAReferFriend';

export default AmexGDAReferFriend;
